import React from "react";
import "./Navbar.css";
import Logo from "./component/Logo";
import { Button } from "primereact/button";

const Navbar = (props) => {
  const { toggleHeader, children } = props;

  return (
    <div className="ContainerHeaderNav">
      <nav className="navbar navbar-dark Navbar">
        <div className="container-fluid ContainerNav">
          <Logo />

          {toggleHeader && (
            <Button
              icon="pi pi-chevron-up"
              className="CloseHeader"
              onClick={toggleHeader}
            />
          )}

          {children}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
